<section class="first">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <p class="clg">
          Showing
          <strong>1050</strong> Pokemons
        </p>

        <div class="list" *ngIf="result.length > 0">
          <div class="row">
            <div *ngFor="let pokemon of result" class="col-md-3 col-sm-4">
              <div class="pcard" (click)="details(pokemon.url.split('/')[6])">
                <div class="img">
                  <app-image
                    src="https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/{{
                      pokemon.url.split('/')[6]
                    }}.png"
                    alt="pokemon.name"
                  ></app-image>
                </div>
                <div class="info">
                  <span class="clg"
                    ><strong>#{{ pokemon.url.split("/")[6] }}</strong></span
                  >
                  <h2>{{ pokemon.name }}</h2>
                  <span class="ico"><i class="icon-arrow-right"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
